import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {TranslateService} from '@ngx-translate/core';

import {AccountService} from '@core/ecv-http-services/services/account.service';
import {AlertService} from '@widgets/alert/alert.service';
import {ValidatorService} from '@core/validator/validator.service';
import {CustomValidators} from '@core/validator/custom-validators';
import {DeleteSpecialistService} from '@core/ecv-http-services/services/delete-specialist.service';
import {AlertUtils} from '../shared/AlertUtils';
import {UserService} from '@core/ecv-http-services/services/user.service';


@Component({
  selector: 'app-delete-specialist',
  templateUrl: './delete-specialist.component.html'
})
export class DeleteSpecialistComponent implements OnInit {
  referenceNumberForm: FormGroup;
  referenceNumber: string;

  constructor(private accountService: AccountService,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private userService: UserService,
              private deleteSpecialistService: DeleteSpecialistService) {

  }

  ngOnInit() {
    this.createForm();
  }

  public deleteSpecialist() {
    this.validatorService.validate(this.referenceNumberForm);
    if (!this.validatorService.isValid(this.referenceNumberForm)) {
      return;
    }

    this.userService.checkIfExpertExists(this.referenceNumber).subscribe(
      response => {
        this.deleteSpecialistService.deleteSpecialist(this.referenceNumber).subscribe(
          response => {
            AlertUtils.showAlert(true, 'ALERT.SPECIALIST_DATA_DELETED', this.translateService, this.alertService);
            this.clearForm();
            this.createForm();
          });
      }, error => {
      });
  }

  private clearForm() {
    this.referenceNumber = undefined;
  }

  private createForm(): void {
    this.referenceNumberForm = new FormGroup({
      'referenceNumber': new FormControl('', [Validators.required, CustomValidators.validateReferenceNumber()])
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/delete-specialist/delete-specialist.component.ts